var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCountryParam } from "@/hooks/useCountryParam";
import { Center, List, useEnvironmentContext, useRecipe, } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import { getNextPageCursor, getPageParams, getPrevPageCursor, } from "@/components/Pagination/PageButtonHelper";
import { NextPageButton } from "./NextPageButton";
import { PageNumberButtons } from "./PageNumberButtons";
import { PrevPageButton } from "./PrevPageButton";
export var PaginationSerp = function (_a) {
    var pageCursors = _a.pageCursors;
    var recipe = useRecipe({ key: "PaginationSerp" });
    var styles = recipe({});
    var _b = useSearchParams(), searchParams = _b[0], setSearchParams = _b[1];
    var countryParam = useCountryParam();
    var environment = useEnvironmentContext();
    if (pageCursors.size === 0) {
        return _jsx(_Fragment, {});
    }
    var handleClick = function (e, cursor) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        setSearchParams(getPageParams(searchParams, cursor, countryParam));
        // The timeout is required as we need to wait for the rendered results to update
        setTimeout(function () {
            environment.getWindow().scrollTo({ top: 0, behavior: "smooth" });
        });
    };
    var prevPageCursor = getPrevPageCursor(pageCursors);
    var nextPageCursor = getNextPageCursor(pageCursors);
    var props = {
        pageCursors: pageCursors,
        pageClickHandler: handleClick,
    };
    return (_jsx(Center, __assign({ as: "nav", "aria-label": "Pagination", css: styles }, { children: _jsxs(List.Root, __assign({ as: "ol", role: "list", variant: "plain", flexDirection: "row" }, { children: [prevPageCursor && (_jsx(List.Item, { children: _jsx(PrevPageButton, __assign({}, props, { pageCursor: prevPageCursor })) })), _jsx(PageNumberButtons, __assign({}, props)), nextPageCursor && (_jsx(List.Item, { children: _jsx(NextPageButton, __assign({}, props, { pageCursor: nextPageCursor })) }))] })) })));
};
